import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusStylePipe } from './status-style.pipe';
import { EntityIconPipe } from './entity-icon.pipe';
import { JoinEntitiesPipe } from './join-entities.pipe';
import { IndeterminateStatePipe } from './indeterminate-state.pipe';
import { StatusLabelPipe } from './status-label.pipe';
import { RemoveParentActorPipe } from './remove-parent-actor.pipe';
import { ChildrenOgusPipe } from './children-ogus.pipe';
import { IsParentOfSelectedEntityPipe } from './is-parent-of-selected-entity.pipe';
import { IsDeploymentDisabledPipe } from './is-deployment-disabled.pipe';
import { IsExclusionDisabledPipe } from './is-exclusion-disabled.pipe';
import { IsEntityDeployedPipe } from './is-entity-deployed.pipe';
import { IsEntityExcludedPipe } from './is-entity-excluded.pipe';
import { ShowExclusionPipe } from './show-exclusion.pipe';

@NgModule({
  declarations: [
    StatusStylePipe,
    EntityIconPipe,
    JoinEntitiesPipe,
    IndeterminateStatePipe,
    StatusLabelPipe,
    RemoveParentActorPipe,
    ChildrenOgusPipe,
    IsParentOfSelectedEntityPipe,
    IsDeploymentDisabledPipe,
    IsExclusionDisabledPipe,
    IsEntityDeployedPipe,
    IsEntityExcludedPipe,
    ShowExclusionPipe
  ],
  exports: [
    StatusStylePipe,
    EntityIconPipe,
    JoinEntitiesPipe,
    IndeterminateStatePipe,
    StatusLabelPipe,
    RemoveParentActorPipe,
    ChildrenOgusPipe,
    IsParentOfSelectedEntityPipe,
    IsDeploymentDisabledPipe,
    IsExclusionDisabledPipe,
    IsEntityDeployedPipe,
    IsEntityExcludedPipe,
    ShowExclusionPipe
  ],
  imports: [
    CommonModule
  ],
  providers: [
    IsDeploymentDisabledPipe,
    IsEntityDeployedPipe,
    RemoveParentActorPipe
  ]
})
export class DeploymentPipesModule {
}
